import { UseGqlMutationCallbacks, useMutationWithInvalidation } from '@alice-financial/api'
import { AddressInput } from '../../generated.types'
import { useCurrentUserQuery } from '../../user/queries/currentUser_gen'
import { useEmployeeQuery } from '../queries/employee_gen'
import { useEmployeeEnrollmentInfoQuery } from '../queries/employeeEnrollmentInfo_gen'
import { UpdateAddressMutation, useUpdateAddressMutation } from './updateAddress_gen'
export type { AddressInput } from '../../../graphql/generated.types'

export const useUpdateAddress = (
  mutationOptions: UseGqlMutationCallbacks<UpdateAddressMutation, AddressInput> = {}
) => {
  const { data: employeeData } = useEmployeeQuery()
  const employeeId = employeeData?.employee?.id
  const { mutateAsync: updateAddress } = useUpdateAddressMutation()
  return useMutationWithInvalidation(
    (mailingAddress: AddressInput) => {
      if (!employeeId) throw new Error('Employee ID not found')
      return updateAddress({ employeeId, mailingAddress })
    },
    mutationOptions,
    [useCurrentUserQuery.getKey(), useEmployeeQuery.getKey(), useEmployeeEnrollmentInfoQuery.getKey()]
  )
}
